import React, { useEffect, useState } from 'react';
import api from '../api/client';
import { FullScreen } from './ui';
import Notifications from '../screens/Notifications';

// Bell with an unread badge that opens the notifications screen.
export default function NotificationBell({ dark }) {
  const [open, setOpen] = useState(false);
  const [unread, setUnread] = useState(0);

  useEffect(() => {
    let alive = true;
    api.get('/notifications')
      .then((d) => { if (alive) setUnread(d?.unread || 0); })
      .catch(() => {});
    return () => { alive = false; };
  }, [open]);

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        aria-label={unread > 0 ? `Notifications, ${unread} unread` : 'Notifications'}
        style={{
          position: 'relative',
          width: 40,
          height: 40,
          borderRadius: '50%',
          background: dark ? 'var(--primary)' : 'rgba(255,255,255,0.18)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flex: 'none',
        }}
      >
        <span style={{ fontSize: 18 }}>🔔</span>
        {unread > 0 && (
          <span
            style={{
              position: 'absolute',
              top: -2,
              right: -2,
              minWidth: 18,
              height: 18,
              borderRadius: 'var(--r-pill)',
              background: '#fff',
              color: 'var(--primary)',
              fontSize: 10,
              fontWeight: 800,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '0 4px',
              border: '2px solid var(--primary)',
            }}
          >
            {unread > 9 ? '9+' : unread}
          </span>
        )}
      </button>

      <FullScreen open={open} onClose={() => setOpen(false)} variant="panel">
        <Notifications onClose={() => setOpen(false)} />
      </FullScreen>
    </>
  );
}
